// removed by extract-text-webpack-plugin
module.exports = {"NewGrey":"#596067","steps":"G7663f4 G19bca4"};